import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import Layout from '@/layout/Layout'
import globalStyle from '@/styles/Global.scss'
import { getPublicCard } from '@/api/card'
import { Card } from '@/entity/Card'
import ImageCard from '@/components/ImageCard'
import AttributeViewer from '@/components/AttributeViewer'

const Showcase = () => {
  const { id } = useParams()
  const [card, setCard] = useState(new Card({}))
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    (async () => {
      try {
        setLoading(true)
        const c = await getPublicCard({ id })
        setCard(c)
      } catch (e) {
        setError('名刺情報の取得に失敗しました。')
      } finally {
        setLoading(false)
      }
    })()
  }, [id])

  return (
    <Layout needTopBar={true} title={'名刺R'} >
      <div className={globalStyle.container}>
        <div className={globalStyle.bodyContainer}>
          <div className={globalStyle.body}>
            <div className={globalStyle.centerPanel}>
              {loading && <div>読み込み中...</div>}
              {error && <div>{error}</div>}
              {!loading && !error && (
                <>
                  <ImageCard id={id} isPublic={true} />
                  <h3>{card.name}</h3>
                  <AttributeViewer attributes={card.attributes} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Showcase
